<template lang="html">
  <div v-if="sizeTableId" class="size-table-section">
    <UButton
      label="Таблица размеров"
      color="tertiary"
      variant="link"
      icon="i-lucide-ruler"
      class="h-auto p-0"
      @click="openGallery()"
    />

    <ClientOnly>
      <template #fallback>
        <div class="hidden" />
      </template>
      <LightgalleryContainer
        v-if="needShowGallery"
        :key="sizeTableId"
        :onInit="handleInitGallery"
      >
        <a :data-src="sizeTableUrl" />
      </LightgalleryContainer>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { PromiseController } from '@repo/alt/common/Utils/Async.js'
import type { ProductDto } from '@repo/api/web/models'
import type { LightGallery } from 'lightgallery/lightgallery'
import 'lightgallery/css/lightgallery.css'

const LightgalleryContainer = defineAsyncComponent(
  () => import('lightgallery/vue'),
)

const props = defineProps<{
  value: ProductDto
}>()

const initGalleryPromise = new PromiseController<LightGallery>()
const { support } = useResources()
const $gallery = ref<LightGallery>()
const needShowGallery = ref(false)

const sizeTable = computed(() => props.value.wellKnownAttributes?.SizeTable)
const sizeTableId = computed(() => sizeTable.value?.id?.trim() || '')
const sizeTableUrl = computed(() =>
  sizeTableId.value ? support.getResourceUrl(sizeTableId.value) : '',
)

async function openGallery() {
  needShowGallery.value = true

  if (!$gallery.value) {
    await initGalleryPromise.promise
  }

  $gallery.value?.openGallery()
}

function handleInitGallery(gallery: { instance: LightGallery }) {
  $gallery.value = gallery.instance
  initGalleryPromise.resolve($gallery.value)
}
</script>
